import { IconName } from '@bytel/trilogy-assets/lib/iconNameEnum';

import { Product } from '@app-types/product';

export enum PACK_HASH {
    SMART_TV = 'smart-tv',
    GAMING = 'gaming',
    PS5 = 'ps5',
    VIDEOPROJECTOR = 'videoprojecteur',
    SMART_MONITOR = 'smart-monitor',
    TABLET = 'tablette',
    IPAD = 'ipad',
}

export enum ProductMetaCategory {
    SAMSUNG = 'samsung',
    SAMSUNG_SMART_TV = 'samsung_smart_tv',
    GAMING = 'gaming',
    TABLET = 'tablette',
}

export type HomePackResponseWithCategories = {
    id?: number;
    stickerProduct?: string;
    stickerProductTooltip?: string;
    categoryProductsSamsung?: HomePackCategory[];
};

export type HomePackCategorySeo = {
    metaDescription?: string;
    metaKeywords?: string;
    title?: string;
};

export type HomePackCategoryHero = {
    title: string;
    subtitle: string;
    backgroundImageUrl: string;
    productImageUrl: string;
};

export type HomePackCategory = {
    slug?: string;
    categoryName?: string;
    savings?: string;
    productsSamsung?: HomepackProduct[];
    seo: HomePackCategorySeo;
    hero: HomePackCategoryHero;
    order: number;
    id: number;
    icon: IconName;
};

export type HomepackProduct = Partial<Product> & {
    techno: string;
    countdownStart: Date;
    countdownEnd: Date;
    productDetails: { iconeTrilogy: IconName; pepite: string }[];
    options: HomepackProductOptions[];
    ctaText: string;
    productAddedText: string;
    externalLink?: {
        text: string;
        url: string;
    };
    brandLogo: string;
    order: number;
    startDate: Date | null;
    endDate: Date | null;
    faiProductsSamsungId: number;
    faiCategoriesSamsungSlug: string;
    image: string;
    name: string;
    id: string;
    partialsUrlKey?: string;
};

export type StoredHomepackProduct = HomepackProduct & {
    slug: PACK_HASH;
    productSize: HomepackProductOptions[];
};

export type HomepackProductOptions = {
    pouces?: string;
    cm?: string;
    sticker?: string;
    stickerMobile?: string;
    price: number;
    priceStriked: number;
    priceDescription?: string;
    defaultProduct?: boolean;
    promo?: boolean;
    urlProduct?: string;
    productReference?: string;
    colorName?: string;
    colorCode?: string;
    energyLabel?: { label?: 'A' | 'B' | 'C' | 'D' | 'E' | 'F' | 'G'; img?: string; pdf?: string };
    durabilityIndex?: number;
    repairabilityIndex?: number;
};

export type StaticPackProduct = {
    mainProduct: HomepackProduct | null;
    details: HomepackProductOptions | null;
};
